module.exports = __webpack_public_path__ + "img/FJ.c6da09fb.png";